var goDown = (function () {

    var cachedDOM = {}

    function init (arrow, section) {
        cachedDOM.$body = $('html, body');
        cachedDOM.$arrow = $(arrow);
        cachedDOM.$section = $(section);

        events();
    }

    function events () {
        cachedDOM.$arrow.on('click', goToSection);
    }

    function goToSection (event) {
        event.preventDefault();

        cachedDOM.$body.animate(
            {
                scrollTop: cachedDOM.$section.offset().top - 30
            },
            600,
            function() {
                cachedDOM.$section.focus();
            }
        );
    }

    return {
        init: init,
        goToSection: goToSection
    }
})();
